import type { components } from "@entities/journal";

type SectionTwoItemInfoRequest =
  components["schemas"]["SectionTwoItemInfoRequest"];

export type SectionTwoRequestPayload = Omit<
  SectionTwoItemInfoRequest,
  "dateHandover"
> & {
  dateHandover?: string | null;
};

type SectionTwoRequestSource = Omit<
  SectionTwoRequestPayload,
  "journalKeepersList"
> & {
  journalKeepersList?: Array<{
    company: SectionTwoItemInfoRequest["journalKeepersList"][number]["company"] & {
      companyName?: string;
    };
    authorizedRepresentativesList: Array<{
      user: SectionTwoItemInfoRequest["journalKeepersList"][number]["authorizedRepresentativesList"][number]["user"] & {
        firstName?: string;
        organization?: string;
        position?: string;
        surname?: string;
      };
    }>;
  }>;
};

const toApiDateTime = (date: string) =>
  /^\d{4}-\d{2}-\d{2}$/.test(date) ? `${date}T00:00:00.000Z` : date;

export const mapSectionTwoRequest = ({
  mainJournalId,
  section2Id,
  section2ListId,
  specialJournalName,
  specialJournalDate,
  journalKeepersList = [],
  dateHandover,
  signer,
}: SectionTwoRequestSource): SectionTwoRequestPayload => ({
  mainJournalId,
  section2Id,
  section2ListId,
  specialJournalName,
  specialJournalDate: toApiDateTime(specialJournalDate),
  journalKeepersList: journalKeepersList.map(
    ({ company, authorizedRepresentativesList }) => ({
      company: {
        companyId: company.companyId,
        projectParticipantId: company.projectParticipantId,
      },
      authorizedRepresentativesList: authorizedRepresentativesList.map(
        ({ user }) => ({
          user: {
            userCompanyHistoryId: user.userCompanyHistoryId,
            userId: user.userId,
          },
        }),
      ),
    }),
  ),
  dateHandover: dateHandover ? toApiDateTime(dateHandover) : dateHandover,
  signer,
});
